import { cn } from "@/lib/cn";
import { WindowEntry } from "./WindowEntry";
import type { WindowEntryChip, WindowEntry as WindowEntryData } from "./types";

type CommonProps = {
    locationName: string;
    entries: WindowEntryData[];
    isFirstGroup: boolean;
};

type LocationGroupProps =
    | (CommonProps & { readonly: true })
    | (CommonProps & {
          readonly?: false;
          onRemoveChip: (entry: WindowEntryData, chip: WindowEntryChip) => void;
      });

export function LocationGroup(props: LocationGroupProps) {
    const { locationName, entries, isFirstGroup } = props;
    return (
        <div>
            <div
                className={cn(
                    "px-7 pt-6 pb-3 bg-gray-50",
                    !isFirstGroup && "border-t border-gray-100",
                )}
            >
                <p className="text-xl font-bold text-gray-900">
                    {locationName}
                </p>
            </div>
            <div className="border-t border-gray-100">
                {entries.map((entry, idx) =>
                    props.readonly ? (
                        <WindowEntry
                            key={entry.windowId}
                            entry={entry}
                            isFirstInGroup={idx === 0}
                            readonly
                        />
                    ) : (
                        <WindowEntry
                            key={entry.windowId}
                            entry={entry}
                            isFirstInGroup={idx === 0}
                            onRemoveChip={(chip) =>
                                props.onRemoveChip(entry, chip)
                            }
                        />
                    ),
                )}
            </div>
        </div>
    );
}
